<template>
  <BaseModal class="present_modal">
      <Product
        :product="product"
        :is-btn-show="false"
        :is-column="false"
      />
      <p class="ab">この製品をプレゼントに選択しますか？</p>
      <slot />
      <div class="btn_wrap mt24">
        <BaseBtn :disabled="disabled" :btnText="'この製品を選ぶ'" :type="disabled ? 'delete' : 'blue'" @onClick="$emit('onClickCorrectProduct')" class="" />
        <BaseBtn :disabled="disabled" :btnText="'前の画面に戻る'" :type="disabled ? 'delete' : 'yellow'" @onClick="$emit('onClickCloseModal')" class="" />
      </div>
    </BaseModal>
</template>

<script>
import BaseModal from "@/components/common/BaseModal.vue";
import BaseBtn from "@/components/common/BaseBtn.vue";
import Product from "@/components/keepgoing/Product.vue";

export default {
  components: {
    BaseBtn,
    BaseModal,
    Product
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="css" scoped>
/* モーダル */
.present_modal .product {
  border: none;
}

.present_modal .product_image {
  width: 40%;
}
.present_modal .product_contents {
  width: 60%;
}

.btn_wrap {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/keepgoing/PresentModal.vue